import { CircularProgress } from "@material-ui/core";

export default function TCLoading({ size, color, ...props }) {
  return (
    <CircularProgress color={color || "inherit"} size={size || 20} {...props} />
  );
}
